import React, { useContext, useEffect, useState } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import MaskedInput from 'react-text-mask';
// --------------------------------------------------

import { buscarDadosPlaca } from '../../services/Api_PlacaFipe';
import { SetFunctions } from '../../componentes/Functions';

import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import { useAvisoEventos } from '../Modal/ModalAvisoEventos';

// /-------------------------------------------------
export function PesquisaPlaca(props) {
    const { state, dispatch } = useContext(Context);
    const { listaPesquisa } = state.parametros;
    const { veiculo } = state.veiculo;

    const { SetParametroInit } = SetFunctions();

    // ------------------------    
    const [veiculoExistenteBD, setVeiculoExistenteBD] = useState(false);
    const [valorFipeNumerico, setValorFipeNumerico] = useState(null);

    const { PesqVeiculoPlaca} = Api_Veiculos();
    const { verificarPlaca: verificarLocal, modalAviso } = useAvisoEventos();
    // Quando o pai fornece o verificador, o modal sobrevive à desmontagem deste componente
    const verificarPlaca = props.verificarPlacaEventos || verificarLocal;
    
    // --------------
    function SetListaPesquisa(key, value) {
        dispatch({
            type: 'set_ListaPesquisa',
            payload: { ...listaPesquisa, [key]: value }
        });
    };

    // --------FUNÇÃO PARA BUSCAR DADOS DA PLACA VIA API FIPE
    const BuscarPlacaFipe = async (placa) => {
        props.setBuscandoDadosPlaca(true);
        props.setErroBuscaPlaca('');
        props.setSucessoBuscaPlaca(false);
        props.setDadosDivergentes(false);
        props.setSituacaoDivergente(false);
        props.setmaioresScoresFipe([]);
        props.setDadosFipeRecebidos(null);
        setValorFipeNumerico(null);
        SetParametroInit('DadosLocalizado', false);

        try {
            const dadosFipeVeiculo = await buscarDadosPlaca(placa);
            if (dadosFipeVeiculo.marca === "") {
                SetParametroInit('NaoLocalizado', true);
                alert("Veiculo Não Localizado!");
                return;
            };

            SetParametroInit('DadosLocalizado', true);
            props.setDadosFipeRecebidos(dadosFipeVeiculo);
            props.setmaioresScoresFipe(dadosFipeVeiculo.maioresScoresFipe || []);

            // dadosFipeVeiculo.situacao verificar se no texto tem a palavra "roubo" ou "furto"
            if (dadosFipeVeiculo.situacao !== "") {
                if (dadosFipeVeiculo.situacao.toLowerCase() !== "Sem restrição".toLowerCase()) {
                    alert(`⚠️ Atenção: Veículo ${placa} está com situação: "${dadosFipeVeiculo.situacao}".`);
                    props.setSituacaoDivergente(true);
                }
            }

            props.setSucessoBuscaPlaca(true);
            setTimeout(() => props.setSucessoBuscaPlaca(false), 3000);

        } catch (error) {
            props.setErroBuscaPlaca('Não foi possível buscar os dados da placa. Verifique se a placa está correta.');
            setTimeout(() => props.setErroBuscaPlaca(''), 5000);
        } finally {
            props.setBuscandoDadosPlaca(false);
        }
    };

    // ------------------------------
    useEffect(() => {
        if (listaPesquisa.nomeItem?.length === 7) {
            PesqVeiculoPlaca(listaPesquisa.nomeItem);
            verificarPlaca(listaPesquisa.nomeItem);
            props.setDadosFipeRecebidos(null);

            dispatch({
                type: 'set_ListaPesquisa',
                payload: { ...listaPesquisa, alertaNovo: false }
            });

        } else {
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaVeiculo: [],
                    listaCliente: [],
                    listaFornecedor: [],
                    alertaNovo: false
                }
            });

            props.setDadosDivergentes(false);
            props.setdadosCompletos(false);
        };

    }, [listaPesquisa.nomeItem]);

    // --------------------------------
    useEffect(() => {
        if (props.dadosFipeRecebidos?.valorFipe) {
            const valorNumerico = props.dadosFipeRecebidos?.valorFipe
            .replace(/[^0-9,.-]+/g, '')
            .replace('R$', '')
            .replace(/\./g, '')
            .replace(',', '.')
            .trim();

            setValorFipeNumerico(valorNumerico);
        }
    }, [props.dadosFipeRecebidos])

    // --------------
    useEffect(() => {
        
    }, [listaPesquisa.nomeItem]);

    // ---- Verificar se veículo já existe no BD-----

    useEffect(() => {
        if (listaPesquisa.listaVeiculo.length > 0) {
            setVeiculoExistenteBD(true);

            const veiculoBD = listaPesquisa.listaVeiculo[0];
            const verificarDados = 
                !veiculoBD.modelo  ||
                !veiculoBD.anoMod  ||
                !veiculoBD.cor  ||
                !veiculoBD.valorFipe  ||
                !veiculoBD.tipo  ||
                !veiculoBD.marca  ||
                !veiculoBD.chassi  ||
                !veiculoBD.situacao ;  

            props.setdadosCompletos(verificarDados? false : true);

            dispatch({
                type: 'set_veiculo',
                payload: { 
                    ...veiculo, 
                    id_Veiculo: veiculoBD._id || '',
                    placa: veiculoBD.placa || '',
                    modelo: veiculoBD.modelo || '',
                    anoMod: veiculoBD.anoMod || '',
                    cor: veiculoBD.cor || '',
                    chassi: veiculoBD.chassi || '',
                    marca: veiculoBD.marca || '',
                    tipo: veiculoBD.tipo || '',
                    valorFipe: veiculoBD.valorFipe || '',
                    situacao: veiculoBD.situacao || '',
                    valorMensal: props.valorMensalCotac
                }
            });

        } else {
            props.setdadosCompletos(false);
            setVeiculoExistenteBD(false);
        }
    }, [listaPesquisa.listaVeiculo]);  

    // -------------COMPARAR BD------------------
    useEffect(() => {
        if (veiculoExistenteBD && props.dadosFipeRecebidos) {
            // Comparar dados para verificar divergências
            const veiculoBD = listaPesquisa.listaVeiculo[0];
            if(veiculoBD !== undefined){    
                const temDivergencias = 
                    veiculoBD.modelo !== props.dadosFipeRecebidos.modelo ||
                    veiculoBD.anoMod !== props.dadosFipeRecebidos.anoModelo ||
                    veiculoBD.cor !== props.dadosFipeRecebidos.cor ||
                    veiculoBD.valorFipe !== valorFipeNumerico ||
                    veiculoBD.valorFipe === "" ||
                    veiculoBD.tipo?.toLowerCase() !== props.dadosFipeRecebidos.tipoVeiculo?.toLowerCase() ||
                    veiculoBD.tipo === "" ||
                    veiculoBD.marca?.toLowerCase() !== props.dadosFipeRecebidos.marca?.toLowerCase() ||
                    veiculoBD.chassi !== props.dadosFipeRecebidos.chassi ||
                    veiculoBD.situacao !== props.dadosFipeRecebidos.situacao;

                props.setDadosDivergentes(temDivergencias);
            }
        }
    }, [veiculoExistenteBD, props.dadosFipeRecebidos, valorFipeNumerico])
    
    // -------------------------
    useEffect(() => {
        if (props.dadosFipeRecebidos) {
            dispatch({
                type: 'set_veiculo',
                payload: {
                    ...veiculo,
                    placa: props.dadosFipeRecebidos.placa,
                    anoMod: props.dadosFipeRecebidos.anoModelo,
                    modelo: props.maioresScoresFipe.length > 1 ? "" : props.dadosFipeRecebidos.modelo ,
                    valorFipe: valorFipeNumerico,
                    cor: props.dadosFipeRecebidos.cor,
                    chassi: props.dadosFipeRecebidos.chassi,
                    tipo: props.dadosFipeRecebidos.tipoVeiculo,
                    marca: props.dadosFipeRecebidos?.marca.toLowerCase(),
                    situacao: props.dadosFipeRecebidos.situacao,
                }
            });
        }
    }, [props.dadosFipeRecebidos, valorFipeNumerico]);
    
    
    //###################################################################################################
    return (
        <S.divInfor>
            {modalAviso}
            <S.divPesq>
                <div style={{display: 'flex',width: '95%',gap: '10px',alignItems: 'flex-end',marginTop:"10px"}}>
                    <div style={{flex: 1, flexDirection:"column"}}>
                        <span>PLACA:</span>
                        <MaskedInput
                        autoFocus
                        value={listaPesquisa.nomeItem}
                        className='uppercase'
                        style={{display:"flex", height:"40px", fontSize:"clamp(16px, 3vw, 18px)"}}
                        type='search'
                        placeholder='Placa do Veículo'
                        mask={[/\D/, /\D/, /\D/, /\d/, /\w/, /\d/, /\d/]}
                        onChange={e => SetListaPesquisa('nomeItem', e.target.value)}
                        guide={false}
                        />
                    </div>

                    {/* Botão BUSCAR FIPE ---------------------------*/}
                    {(listaPesquisa.nomeItem.length === 7 && !props.dadosCompletos) && (
                        <button
                            type='button'
                            onClick={() => BuscarPlacaFipe(listaPesquisa.nomeItem)}
                            disabled={props.buscandoDadosPlaca}
                            style={{
                                backgroundColor: props.buscandoDadosPlaca ? '#666' : '#00D594',
                                color: props.buscandoDadosPlaca ? '#ccc' : '#000',
                                padding: '10px 20px',
                                height: '40px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: props.buscandoDadosPlaca ? 'not-allowed' : 'pointer',
                                whiteSpace: 'nowrap',
                                transition: 'all 0.3s ease',
                                boxShadow: props.buscandoDadosPlaca ? 'none' : '0 2px 4px rgba(0, 213, 148, 0.3)',
                            }}
                            onMouseEnter={(e) => {
                                if (!props.buscandoDadosPlaca) {
                                    e.target.style.backgroundColor = '#00ff9d';
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 4px 8px rgba(0, 213, 148, 0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!props.buscandoDadosPlaca) {
                                    e.target.style.backgroundColor = '#00D594';
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 2px 4px rgba(0, 213, 148, 0.3)';
                                }
                            }}
                        >
                            {props.buscandoDadosPlaca ? '🔄 BUSCANDO...' : '🔍 BUSCAR FIPE'}
                        </button>
                    )}
                </div>
                <div style={{width: '100%', marginTop: '10px', borderBottom: '1px solid #3881ff'}}/>
            </S.divPesq>
        </S.divInfor>
    )
}